module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"noprediction":"Нет прогноза на этот день","month1":"Январь","month2":"Февраль","month3":"Март","month4":"Апрель","month5":"Май","month6":"Июнь","month7":"Июля","month8":"Август","month9":"Сентябрь","month10":"Октябрь","month11":"Ноябрь","month12":"Декабрь"}}')
  delete Component.options._Ctor
}
